import {createAction, props} from "@ngrx/store"
import { Usuario, UsuarioRedux } from 'src/app/models/usuario.model';
import { Rol } from "src/app/modulos/admin/models/rol";
import { ElementoNivelPermisoInterface } from "src/app/modulos/catalogos-admin/models/elementoNivelPermiso.interface";
import { PlanInstitucional } from "src/app/modulos/catalogos-admin/models/plan-institucional";
import { PlanAniosInterface } from "src/app/modulos/catalogos-admin/models/plan.anios.interface";
import { Ambiente } from "src/app/modulos/catalogos-proces/models/ambiente";

export const ambienteSeleccionado = createAction(
    '[GLOBAL] Global Ambiente', props<{ambiente:Ambiente, rol: Rol}>()
    );

export const ambienteSeleccionadoSuccess = createAction(
    '[GLOBAL] Global Ambiente Success', props<{ambiente:Ambiente, rol: Rol}>());

export const ambienteSeleccionadoError = createAction(
    '[GLOBAL] Global Ambiente Error', props<{payload: any}>());


export const planInstitucionalSeleccionado = createAction(
    '[GLOBAL] Global Plan Institucional', props<{idPlan:number}>());

export const planInstitucionalSeleccionadoSuccess = createAction(
    '[GLOBAL] Global Plan Institucional Success', props<{plan:PlanInstitucional}>());

export const planInstitucionalSeleccionadoError = createAction(
    '[GLOBAL] Global Plan Institucional Error', props<{payload: any}>());


export const planAniosSeleccionado = createAction(
    '[GLOBAL] Global Plan Años', props<{idPlan:number}>());

export const planAniosSeleccionadoSuccess = createAction(
    '[GLOBAL] Global Plan Años Success', props<{plan:PlanAniosInterface}>());

export const planAniosSeleccionadoError = createAction(
    '[GLOBAL] Global Plan Años Error', props<{payload: any}>());


export const elementoNivelPermiso = createAction(
    '[GLOBAL] Elemento nivel permiso'
);

export const elementoNivelPermisoSuccess = createAction(
    '[GLOBAL] Elemento nivel permiso Success', props<{elementNivelPermis:ElementoNivelPermisoInterface[]}>());

export const elementoNivelPermisoError = createAction(
    '[GLOBAL] Elemento nivel permiso Error', props<{payload: any}>());
